import { saveUserDetail, editUserDetail, deleteUserDetail } from './api'
import { userDetailSlice } from './reducer'

const { updateStudentInformation } = userDetailSlice.actions

export {
  saveUserDetail,
  editUserDetail,
  deleteUserDetail,
  updateStudentInformation
}
